import React from 'react';
import SubjectCategoryList from '../../components/SubjectCategoryList';

const SubjectCategories = () => {
    return <SubjectCategoryList favoritesOnly={false} />;
};

export default SubjectCategories;
